import React, { Component, useState } from "react";
import GoogleMapReact from "google-map-react";
import api from "../../store/api";
import { showNavbar } from "../../store/modules/appStateSlice";
import { useDispatch, useSelector } from "react-redux";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import Button from "@material-ui/core/Button";
import Navbar from "../shared/Navbar";
import { RootState } from "../../store/rootReducer";
import UserPaneModal from "./userPane/UserPaneModal";
import { useHistory } from "react-router-dom";
import VehicleMarker from "../shared/VehicleMarker";
import { IVehicleLocation } from "../../common/types";
import { consts } from "../../common/consts";

function NavRightMenu(props: any): JSX.Element {
  return (
    <Button onClick={props.rightButtonClick} endIcon={<KeyboardArrowDownIcon />} style={{ color: "#FFF" }}>
      {props.userName}
    </Button>
  );
}

const getCoordDist = (lat1: number, lon1: number, lat2: number, lon2: number) => {
  var p = 0.017453292519943295;
  var c = Math.cos;
  var a = 0.5 - c((lat2 - lat1) * p) / 2 + (c(lat1 * p) * c(lat2 * p) * (1 - c((lon2 - lon1) * p))) / 2;

  return 12742 * Math.asin(Math.sqrt(a));
};

const getMaxDistance = (coords: IVehicleLocation[]) => {
  let maxDistance = 0;
  for (let i = 0; i < coords.length; i++) {
    for (let j = i + 1; j < coords.length; j++) {
      const { latitude: lat1, longitude: lon1 } = coords[i];
      const { latitude: lat2, longitude: lon2 } = coords[j];
      const currentDistance = getCoordDist(lat1 / 1000000, lon1 / 1000000, lat2 / 1000000, lon2 / 1000000);
      if (currentDistance > maxDistance) {
        maxDistance = currentDistance;
      }
    }
  }
  return maxDistance;
};

const TrackFleet = () => {
  const [nearestVehicles, setNearestVehicles] = useState<IVehicleLocation[]>([]);
  const dispatch = useDispatch();
  const { authStore } = useSelector((state: RootState) => state);
  const history = useHistory();

  const [zoom, setZoom] = useState(10);
  const [selectedVehicle, setSelectedVehicle] = useState("");
  const [center, setCenter] = useState({ lat: -33.85679100870898, lng: 151.21529457809382 });
  const [pollingTrigger, setPollingTrigger] = useState<number>(0);
  const [firstTimeZoom, setFirstTimeZoom] = useState(true);

  const [AVdialogIsOpen, setAVDialogIsOpen] = React.useState(false);
  const AVopenDialog = () => setAVDialogIsOpen(true);
  const AVcloseDialog = () => setAVDialogIsOpen(false);

  const PRIMARY_COLOR = "#02489D",
    SECONDARY_COLOR = "#458F6D";

  React.useEffect(() => {
    dispatch(showNavbar(false));
    consumeAPI();
    startPolling();
  }, []);

  React.useEffect(() => {
    consumeAPI();
  }, [pollingTrigger]);

  const startPolling = () => {
    setInterval(() => {
      setPollingTrigger(Math.random() + Math.random());
    }, 20000);
  };

  React.useEffect(() => {
    setNearestVehicles((prev: IVehicleLocation[]) =>
      prev.map((item: IVehicleLocation) =>
        item.objectNo == selectedVehicle ? { ...item, color: SECONDARY_COLOR } : { ...item, color: PRIMARY_COLOR }
      )
    );
  }, [selectedVehicle]);

  React.useEffect(() => {
    if (nearestVehicles.length <= 0) return;
    if (firstTimeZoom == false) return;
    const { latitude: totalLat, longitude: totalLng } = nearestVehicles.reduce((a: IVehicleLocation, b: IVehicleLocation) => {
      return { latitude: a.latitude + b.latitude, longitude: a.longitude + b.longitude };
    });
    if (selectedVehicle == "") {
      setCenter({ lat: totalLat / (nearestVehicles.length * 1000000), lng: totalLng / (nearestVehicles.length * 1000000) });
      setZoom(Math.log2((8192 * window.innerHeight) / (getMaxDistance(nearestVehicles) * 90)));
    }
    setFirstTimeZoom(false);
  }, [nearestVehicles]);

  const consumeAPI = () => {
    api
      .trackWebFleetNearestVehicles("", {
        vehicle: "2701",
        addrno: "E4:04:39:56:F2:CF",
        latitude: 0,
        longitude: 0,
        priority: 1,
        maxdistance: 1000,
        timeZone: "Australia_NSW",
      })
      .then(({ model: { results } }) => {
        // Filter only for test purpose should be removed in future
        results = results.filter(
          (item: IVehicleLocation) =>
            item.latitude < -10000000 && item.latitude > -40000000 && item.longitude < 170000000 && item.longitude > 100000000
        );
        setNearestVehicles(
          results.map((item: IVehicleLocation) =>
            item.objectNo == selectedVehicle ? { ...item, color: SECONDARY_COLOR } : { ...item, color: PRIMARY_COLOR }
          )
        );
        if (selectedVehicle != "") {
          const { latitude, longitude } = results.find((item: IVehicleLocation) => item.objectNo == selectedVehicle);
          setCenter({ lat: latitude / 1000000, lng: longitude / 1000000 });
        }
      });
  };

  const selectSingleVehicle = async ({ latitude, longitude, objectNo }: any) => {
    setSelectedVehicle((prev) => (prev == objectNo ? "" : objectNo));
    setCenter({ lat: latitude / 1000000, lng: longitude / 1000000 });
  };

  return (
    <React.Fragment>
      <Navbar
        humberMenu={
          <Button style={{ padding: 0, minWidth: 50, height: "100%", color: "#FFF" }} onClick={() => history.goBack()}>
            <KeyboardArrowLeftIcon />
          </Button>
        }
        rightButton={<NavRightMenu userName={authStore?.data?.givenName ?? ""} rightButtonClick={AVopenDialog} />}
      />
      <div style={{ height: "100%", width: "100%" }}>
        {nearestVehicles.length > 0 && (
          <GoogleMapReact
            options={{ draggable: true }}
            bootstrapURLKeys={{ key: consts.GooglePlaceAPIKey }}
            defaultCenter={center}
            center={center}
            defaultZoom={zoom}
            zoom={zoom}
          >
            {nearestVehicles.map(({ latitude, longitude, objectNo, color = PRIMARY_COLOR }: any) => {
              return (
                <VehicleMarker
                  key={objectNo}
                  onClick={() => selectSingleVehicle({ latitude, longitude, objectNo })}
                  color={color}
                  lat={latitude / 1000000}
                  lng={longitude / 1000000}
                  vehicleNumber={objectNo}
                />
              );
            })}
          </GoogleMapReact>
        )}
      </div>
      <UserPaneModal open={AVdialogIsOpen} onClose={AVcloseDialog} />
    </React.Fragment>
  );
};

export default TrackFleet;
